/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Awaiting_ReplyInputs */

const en_status_awaiting_reply = /** @type {(inputs: Status_Awaiting_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`awaiting reply`)
};

const he_status_awaiting_reply = /** @type {(inputs: Status_Awaiting_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ממתין לתשובה`)
};

/**
* | output |
* | --- |
* | "awaiting reply" |
*
* @param {Status_Awaiting_ReplyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_awaiting_reply = /** @type {((inputs?: Status_Awaiting_ReplyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Awaiting_ReplyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_awaiting_reply(inputs)
	return he_status_awaiting_reply(inputs)
});